import { E_NAV_KEY, E_ROUTER_NAME, E_ROUTER_PARAMS } from '@pharmsnap/pharmsnap-web/types/enum'
import { createWebTitle } from '@pharmsnap/pharmsnap-web/utils/business/document-title'
import type { RouteConfig } from 'vue-router'

const meta = {
  activeKey: E_NAV_KEY.HOMEPAGE,
}

export default [
  {
    path: `ls/chat/:${E_ROUTER_PARAMS.CHAT_ID}`,
    name: E_ROUTER_NAME.LS_CHAT,
    props: (route) => ({
      id: route.params[E_ROUTER_PARAMS.CHAT_ID],
    }),
    component: () => import('@pharmsnap/pharmsnap-web/views/chat/ChatDetail'),
    meta: {
      ...meta,
      title: createWebTitle('生物医药百科问答', 'Hiro LS Researcher'),
      notWide: true,
    },
  },
  {
    path: `ls/chat/share/:${E_ROUTER_PARAMS.CHAT_SHARE_ID}`,
    name: E_ROUTER_NAME.LS_CHAT_SHARE,
    props: (route) => ({
      id: route.params[E_ROUTER_PARAMS.CHAT_SHARE_ID],
    }),
    component: () => import('@pharmsnap/pharmsnap-web/views/chat/ChatShare'),
    meta: {
      ...meta,
      title: createWebTitle('分享对话', 'Share Chat'),
      notWide: true,
    },
  },
] as RouteConfig[]
